// hardcoded for now, we would want to have it injected dynamically
export const VERSION = "1.20.0";
